module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/api-b90dcdec436321530661a9d9c20c0167.svg";